var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('v-main',[_c('v-container',{staticClass:"fill-height justify-center"},[_c('v-progress-circular',{staticClass:"font-weight-bold",attrs:{"color":"primary","indeterminate":"","size":"250","width":"5"}},[_vm._v(" "+_vm._s(_vm.$t("Please wait..."))+" ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }